import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    margin-top: -10px;
    opacity: 0;
  }
  to {
    margin-top: 15px;
    opacity: 1;
  }
`;

const fadeIn = keyframes`
  0% {
    margin-top: -50px;
    opacity: 0;
  }
  50% {
    margin-top: -50px;
    opacity: 0;
  }
  100% {
    margin-top: 0;
    opacity: 1;
  }
`;

export const ListElementWrapper = styled.li`
  display: flex;
  animation: ${slideIn} 200ms ease-out;
  margin-top: 15px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.span.attrs({ className: 'body_text' })`
  margin-bottom: 5px;
`;

export const LastRow = styled.div`
  margin-top: 15px;
  display: flex;
`;

export const SlideIn = styled.div`
  animation: ${fadeIn} 400ms ease-in-out;
`;
